import * as types from './actionTypes';
import businessCardService from '../../libs/Services/BusinessCardService';
import ImageService from '../../libs/Services/ImageService';
import transformBusinessCard from '../../libs/utils/transformBusinessCard';
import { actions as snackbarActions } from '../SnackBar';
import { selectors as businessCardSelectors } from '../BusinessCard';
import Notification from '../../libs/models/notification';
import { actions } from '../LoadingIndicator';
const { showLoadingIndicator , hideLoadingIndicator } = actions;

export const closeCardModal = () => ({
    type:types.closeCardModal
})

export const openCardModal = () => ({
    type:types.openCardModal
})

export const editCardSetting = (level,setting,value) =>({
    type: types.editSetting,
    payload:{
        'level':level,
        'setting':setting,
        'value': value
    }
});

export const editClientInfo = (property,value) => ({
    type: types.editClientInfo,
    payload:{
        'property': property,
        'value': value
    }
});

export const resetBusinessCard = () => ({
    type: types.resetCard
});

export function reset(){

    return dispatch => {
        dispatch(resetBusinessCard());
        dispatch(snackbarActions.enqueueSnackbar(Notification('Blank card created','success')));
    }
}

export const fetchBusinessCardPending = (businessName) =>({
    type: types.fetchCard,
    businessName: businessName
});

export const fetchBusinessCardSuccess = (businessCard) =>({
    type: types.fetchCardSuccess,
    payload:businessCard
});

export const fetchBusinessCardError = (error) => ({
    type: types.fetchCardError,
    payload: {error: error}
});

//Thunks

export function fetchCardSettings(businessName){
    
    return dispatch => {
        
        dispatch(fetchBusinessCardPending(businessName));
        // dispatch(snackbarActions.enqueueSnackbar(Notification('fetching card... ','info')))

        businessCardService.fetchBusinessCard(businessName)
        .then(res => {

            const businessCard = res;
           // const transformedCard = transformBusinessCard(businessCard);
            // businessCard.actions = businessCard.actions.map(action => action.name);
            dispatch(fetchBusinessCardSuccess(businessCard));
            dispatch(snackbarActions.enqueueSnackbar(Notification('card fetched successfully','success')));
            return businessCard;
        })
        .catch(error => {
            console.log(error)
            dispatch(fetchBusinessCardError(error));
            dispatch(snackbarActions.enqueueSnackbar(Notification('could not fetch card','error')));
        });

    }
    
}

export function updateCardSettings(businessName,businessCard){

    //HINT: you can use getState to get additional state for example like the files list , and if there are any files call the fileUploadService
    return async (dispatch,getState) => {
        
        const state = getState();
        let shouldAddOrUpdateCard = true;
        //TODO: use getState to get the businessCard instead of using the businessCardArg
        console.log('update dispatched')
        console.log(businessCard)
        dispatch(fetchBusinessCardPending(businessCard));
        console.log('card service')
        console.log(businessCardService);

        const deletedActions = businessCardSelectors.getCardDeletedActions(state);

        //TODO: find a way to do this in an elegant way
        //take into account that it will contain deletedImages? 
        const images = businessCardSelectors.getCardImages(state);
        const {deletedImages , ...rest} = images;
        const {galleryImages , ...otherImageTypes} = rest;
        const otherImages = Object.values(otherImageTypes);
        const allImages = galleryImages.length > 0 ? galleryImages.concat(otherImages) : otherImages;
        const imagesToUpload = Object.values(allImages).filter(image => image!==null && image.isLocal);
        

        //uploadfiles via service 
        //TODO: this should be called only if there are files to upload...
        try{

            dispatch(showLoadingIndicator());
            dispatch(snackbarActions.enqueueSnackbar(Notification('please wait ... ','warning')));

            console.log('images to upload')
            console.log(rest)
            console.log(imagesToUpload)

            let uploadedImages;

            if(imagesToUpload.length > 0){

                dispatch(snackbarActions.enqueueSnackbar(Notification('uploading images , please wait ... ','info')));
                const uploadResult = await ImageService.uploadImages(imagesToUpload)
                
                if(uploadResult.succeded){
                    //set the returned images into the state?
                    console.log("upload result")
                    console.log(uploadResult)
                    uploadedImages = uploadResult.images;
                    dispatch(snackbarActions.enqueueSnackbar(Notification('files uploaded successfully','success')));
                }
                else{
                    shouldAddOrUpdateCard = false;
                    dispatch(snackbarActions.enqueueSnackbar(Notification('could not upload files','error')));
                }
    
            }
    
            let result;

            if(shouldAddOrUpdateCard){
                //TODO: do something to avoid doing this everytime you send the card

                console.log(allImages)
                const cardImages = allImages.filter(image => image!==null && !image.isLocal && image.baseFilename !== undefined );
                businessCard.actions = businessCard.cardActions.actions;
                businessCard.images = uploadedImages ? uploadedImages.concat(Object.values(cardImages)) : cardImages;

                console.log('cardImages');
                console.log(businessCard.images);

                console.log('card in publish')
                console.log(businessCard)
                console.log('uploaded images');
                console.log(uploadedImages);
                console.log('card stauts');
                console.log(businessCard.clientInfo.status);

                if(businessCard.clientInfo.status==='NEW'){
                    console.log('creating card')
                    result = await businessCardService.createBusinessCard(businessCard);
                }
                else{
                    result = await businessCardService.updateBusinessCard(businessCard,deletedActions,deletedImages);
                }
        
                if(result.success){
        
                    const businessCard = result.data;
                    console.log('update card result')
                    console.log(businessCard)
                    //const transformedCard = transformBusinessCard(businessCard);
                    //console.log(transformedCard)

                    dispatch(fetchBusinessCardSuccess(businessCard));
                    dispatch(snackbarActions.enqueueSnackbar(Notification('card updated successfully','success')));

                    return businessCard;
        
                }
                else{
                    throw(result.error);
                }
            }

        }
        catch(e){
            console.log('publish error')
            console.log(e)
            dispatch(fetchBusinessCardError(e));
            dispatch(snackbarActions.enqueueSnackbar(Notification('could not update card','error')));
        }   
        finally{
            dispatch(hideLoadingIndicator());
        }
    }

}